import NProgress from 'nprogress';
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_ATS_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../../Base/helper/baseFunctions";
import { toast } from 'react-toastify';

// Setting ATS Hiring Request Config 
export const fnGetMprDetailsHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ats/ancillary/getMprDetails`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
        }
    })
        .then((res) => {
            NProgress.done();
            return { message: "Success", hasError: false, data: res?.data };
        }).catch(err => {
            NProgress.done();
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
};

export const fnUpdateMprDetailsHelper = async (params) => {
    toast.dismiss();
    toast.info("Updating...");
    return await axiosInstance(`/ats/ancillary/updateMprDetails`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
            flag: params?.flag,
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("MPR Mandatory updated successfully");
            return { message: "Success", hasError: false, data: res?.data };
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Error", hasError: true, data: err?.response?.data };
        });
};

// MPR ID Configuration Helpers
export const GetMPRIDHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ats/ancillary/getMPRID`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name:getDomain(),
        }
    })
        .then((res) => {
            NProgress.done();
            return { message: "Success", hasError: false, data: res?.data };
        }).catch(err => {
            NProgress.done();
            return { message: "Failed", hasError: true, data: err?.response?.data || err?.data };
        });
};

export const UpdateMPRIDHelper = async (params) => {
    toast.dismiss();
    toast.info("Updating...");
    return await axiosInstance(`/ats/ancillary/updateMPRID`, {
        method: "PUT",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            prefix: params?.prefix || "",
            suffix: params?.suffix || "",
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("MPR ID Configuration Updated Successfully");
            return { message: "Success", hasError: false, data: res?.data };
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Failed to update MPR ID configuration");
            return { message: "Failed", hasError: true, data: err?.response?.data || err?.data };
        });
};

// Offer Letter ID Configuration Helpers
export const GetOfferLetterIDHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ats/ancillary/getOfferLetterID`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
        }
    })
        .then((res) => {
            NProgress.done();
            return { message: "Success", hasError: false, data: res?.data };
        }).catch(err => {
            NProgress.done();
            return { message: "Failed", hasError: true, data: err?.response?.data || err?.data };
        });
};

export const UpdateOfferLetterIDHelper = async (params) => {
    toast.dismiss();
    toast.info("Updating...");
    return await axiosInstance(`/ats/ancillary/updateOfferLetterID`, {
        method: "PUT",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            prefix: params?.prefix || "",
            suffix: params?.suffix || "",
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Offer Letter ID Configuration Updated Successfully");
            return { message: "Success", hasError: false, data: res?.data };
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Failed to update Offer Letter ID configuration");
            return { message: "Failed", hasError: true, data: err?.response?.data || err?.data };
        });
};

